export default {
  title: 'New Profile',
  title_edit: 'Editing Profile'
}
